export default __webpack_public_path__ + "static/media/active-data-sharing-icon.59cade9b.svg";